<template>
  <div class="xl_hide l_hide m_hide col_s_12">
    <div class="mob_user_nav">
      <router-link to="/user_rooms" class="hover_op">Rooms</router-link>
      <router-link to="/user_subscriptions" class="hover_op"
        >Subscription</router-link
      >
      <router-link to="/user_profile" class="hover_op">Profile</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "mobileUserNav",
};
</script>

<style lang="scss">
.mob_user_nav {
  display: flex;
  margin-bottom: 64px;
  padding-bottom: 15px;
  margin-left: 16px;
  margin-right: 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.16);

  a {
    flex: 1 1 auto;
    opacity: 0.32;
    color: #000;
    font-family: "Nunito Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;

    &.router-link-active {
      opacity: 1;
      font-family: "Nunito Sans", sans-serif;
      font-weight: 700;

      &:after {
        content: "";
        display: block;
        position: absolute;
        bottom: -16px;
        width: 100%;
        height: 1px;
        background-color: #000;
      }
    }
  }
}
</style>